import * as types from './mutation_types';

export default {
  [types.JOURNEY_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.JOURNEY_RESET](state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      items: [],
      position: {},
      steps: 0,
      track: 'none',
      days: 0,
      maxSteps: 0,
      pendingTrainerWin: null,
    });
  },

  [types.JOURNEY_SET_LOADING](state, loading) {
    Object.assign(state, { isLoading: loading });
  },

  [types.JOURNEY_SET_ITEMS](state, items) {
    Object.assign(state, { items: items });
  },

  [types.JOURNEY_SET_POSITION](state, position) {
    Object.assign(state, { position: position, pendingTrainerWin: null });
  },

  [types.JOURNEY_SET_PENDING_TRAINER_WIN](state, pendingTrainerWin) {
    Object.assign(state, { pendingTrainerWin: pendingTrainerWin });
  },

  [types.JOURNEY_SET_TRACK](state, track) {
    Object.assign(state, { track: track });
  },

  [types.JOURNEY_SET_BUTTON_VOLUME](state, buttonVolume) {
    Object.assign(state, { buttonVolume: buttonVolume });
  },

  [types.JOURNEY_SET_MUSIC_VOLUME](state, musicVolume) {
    Object.assign(state, { musicVolume: musicVolume });
  },
};
